import $ from "jquery";
import cssGenJsonFormater from "./cssGenJsonFormater";

const scssFormater = () => {
  const init = () => {
    handleOnChangeRadio();
    handleOnClickSubmit();
  };

  const el = {
    dashboard: ".figma-variable-exporter",
    title: ".js-title",
    radio: `[name="feature-selector"]`,
    textInput: ".js-input",
    submitBtn: ".js-btn-submit",
    output: ".output-wrapper",
  };

  const handleOnChangeRadio = () => {
    $(el.radio).on("click", (e) => {
      const thisElement = $(e.target.closest(el.radio));
      switch (thisElement.val()) {
        case "typograph":
          document.querySelector(el.title).innerHTML = "Convert Typograph";
          $(el.textInput).attr(
            "placeholder",
            `$typographyVariables: (
              "h1-bold-color": map-get($colors, "gray-900"),
              "h1-bold-font-family": "Inter",
              "h1-bold-font-size": rem(72px),
              "h1-bold-font-style": normal,
              "h1-bold-font-weight": 700,
              "h1-bold-letter-spacing": -0.02em,
              "h1-bold-line-height": rem(90px),
              "h1-bold-text-transform": none,
            );`
          );
          break;
        case "color":
          document.querySelector(el.title).innerHTML = "Convert Color";
          $(el.textInput).attr(
            "placeholder",
            `$green: #378b36;\n$neu-0: #ffffff;\n$neu-80: #494945;\n$neu-100: #1c1b17;`
          );
          break;
      }
    });
  };

  const handleOnClickSubmit = () => {
    document.querySelector(el.submitBtn).addEventListener("click", (e) => {
      document.querySelector(el.output).innerHTML = "";
      const thisElement = e.target.closest(el.submitBtn);
      const wrapper = thisElement.closest(el.dashboard);
      const textInput = wrapper.querySelector(el.textInput);
      const selectedFeature = document.querySelector(
        `${el.radio}:checked`
      ).value;
      switch (selectedFeature) {
        case "typograph":
          /* eslint-disable */
          const { typographyJsonFormaterCssGen } = cssGenJsonFormater();
          const { jsonTypographyVariables } = typographyJsonFormaterCssGen(
            textInput.value
          );
          handleScssTypographOutputElement(jsonTypographyVariables);
          const { elementorFormatTypography } =
            handleJsonToElementorTypographyFormat(jsonTypographyVariables);
          console.log(elementorFormatTypography);
          handleAjaxInjectDb(elementorFormatTypography);
          /* eslint-enable */
          break;
        case "color":
          /* eslint-disable */
          const { colorJsonFormaterCssGen } = cssGenJsonFormater();
          const { jsonColorVariables } = colorJsonFormaterCssGen(
            textInput.value
          );
          handleScssColorOutputElement(jsonColorVariables);
          const { elementorFormatColors } =
            handleJsonToElementorColorFormat(jsonColorVariables);
          handleAjaxInjectDb(elementorFormatColors);
          /* eslint-enable */
          break;
      }
    });
  };

  const handleScssColorOutputElement = (jsonColorVariables) => {
    const elementScssColorArray = `<div>
      <h2>SCSS Array of Colors</h2>
     <strong>$colors: (</strong>
        <div>
        ${jsonColorVariables
          .map((item) => {
            return `<span><strong>"${item.name}"</strong>: ${item.hexValue},</span>`;
          })
          .toString()
          .replaceAll(">,", ">")}
        </div>
     <strong>);</strong>
    </div>`;
    document.querySelector(el.output).innerHTML = elementScssColorArray;
    const elementScssColorVariable = `<div>
          <h2>SCSS Color Variables</h2>
      ${jsonColorVariables
        .map((item) => {
          return `<span>$${item.name}: map.get($colors, "${item.name}");</span>`;
        })
        .toString()
        .replaceAll(">,", ">")}
    </div>`;
    document
      .querySelector(`${el.output} > div`)
      .insertAdjacentHTML("afterend", elementScssColorVariable);
    $(el.output).removeClass("typography-output");
    $(el.output).addClass("output-wrapper color-output");
  };

  const handleJsonToElementorColorFormat = (jsonColorVariables) => {
    const elementorFormatColors = {
      name: "custom_colors",
      value: [],
    };
    jsonColorVariables?.map((itemColor) => {
      let elementorColorVariable = {
        _id: Math.random().toString(36).slice(2, 9),
        title: itemColor?.name,
        color: itemColor.hexValue,
      };
      elementorFormatColors.value.push(elementorColorVariable);
    });

    return { elementorFormatColors };
  };

  const handleJsonToElementorTypographyFormat = (jsonTypographyVariables) => {
    const elementorFormatTypography = {
      name: "custom_typography",
      value: [],
    };

    jsonTypographyVariables.map((itemTypography) => {
      const itemTypographyObject = {
        _id: Math.random().toString(36).slice(2, 9),
        title: itemTypography.name,
        typography_typography: "custom",
        typography_font_family: itemTypography.cssProps["font-family"],
        typography_font_size: {
          unit:
            itemTypography.cssProps["font-size"]?.slice(
              itemTypography.cssProps["font-size"].length - 2,
              itemTypography.cssProps["font-size"].length
            ) || "px",
          size:
            itemTypography.cssProps["font-size"]?.slice(
              0,
              itemTypography.cssProps["font-size"].length - 2
            ) || "16",
          sizes: [],
        },
        typography_font_weight: itemTypography.cssProps["font-weight"],
        typography_line_height: {
          unit:
            itemTypography.cssProps["line-height"]?.slice(
              itemTypography.cssProps["line-height"].length - 2,
              itemTypography.cssProps["line-height"].length
            ) || "em",
          size:
            itemTypography.cssProps["line-height"]
              ?.slice(0, itemTypography.cssProps["line-height"].length - 2)
              .replaceAll(" ", "") || "1.5",
          sizes: [],
        },
        typography_letter_spacing: {
          unit:
            itemTypography.cssProps?.["letter-spacing"]?.slice(
              itemTypography.cssProps?.["letter-spacing"].length - 2,
              itemTypography.cssProps?.["letter-spacing"].length
            ) || "em",
          size:
            itemTypography.cssProps?.["letter-spacing"]?.slice(
              0,
              itemTypography.cssProps?.["letter-spacing"].length - 2
            ) || "0",
          sizes: [],
        },
      };
      elementorFormatTypography.value.push(itemTypographyObject);
    });

    return { elementorFormatTypography };
  };

  const handleScssTypographOutputElement = (jsonTypographyVariables) => {
    const elementMixins = `<div>
      <h2>Mixins</h2>
      ${jsonTypographyVariables
        .map((item) => {
          return `<div class="mixin-item">
          <div>@mixin ${item.name} { </div>
            <span>font-family: "${item.cssProps["font-family"]}", sans-serif;</span>
            <span>font-size: ${item.cssProps["font-size"]};</span>
            <span>font-weight: ${item.cssProps["font-weight"]};</span>
            <span>line-height: ${item.cssProps["line-height"]};</span>
          <div>}</div>
        </div>`;
        })
        .toString()
        .replaceAll(">,", "")}
    </div>`;
    document.querySelector(el.output).innerHTML = elementMixins;
    const elementBaseClass = `<div>
      <h2>Base Class</h2>
      ${jsonTypographyVariables
        .map((item) => {
          return `<div class="mixin-item">
          <div>.${item.name} { </div>
            <span>@include typo-mixins.${item.name};</span>
          <div>}</div>
        </div>`;
        })
        .toString()
        .replaceAll(",", "")}
    </div>`;
    document
      .querySelector(`${el.output} > div`)
      .insertAdjacentHTML("afterend", elementBaseClass);
    $(el.output).removeClass("color-output");
    $(el.output).addClass("output-wrapper typography-output");
  };

  const handleAjaxInjectDb = (data) => {
    $.ajax({
      url: parameters.url_admin_ajax,
      type: "POST",
      data: {
        action: parameters.action,
        nonce: "asdasdasd",
        // data: data,
        data: data,
      },
      success: function (response) {
        // Handle the response from the server
        console.log(response);
      },
      error: function (xhr, status, error) {
        // Handle any errors that occurred during the request
        console.error(xhr.responseText);
      },
    });
  };

  init();
};

try {
  scssFormater();
} catch (error) {
  console.log(error);
}
